import React from 'react';

const EnergyMono = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.03076 22.0001C8.34427 16.9156 11.0324 12.4737 14.9997 9.76956"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.9693 22.0001C39.6558 16.9156 36.9676 12.4737 33.0003 9.76956"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 46L21.7361 27.7712"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.2639 27.7712L28 46"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 18.9998V5C21 3.34315 22.3431 2 24 2C25.6568 2 27 3.34314 27 5V18.9998"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0358 27.5982L9.91157 34.5981C8.47669 35.4265 6.64192 34.9349 5.8135 33.5V33.5C4.98507 32.0651 5.4767 30.2304 6.91157 29.4019L19.0358 22.402"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.9643 27.5982L38.0885 34.5981C39.5234 35.4265 41.3581 34.9349 42.1866 33.5V33.5C43.015 32.0651 42.5234 30.2304 41.0885 29.4019L28.9643 22.402"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 28C26.7614 28 29 25.7614 29 23C29 20.2386 26.7614 18 24 18C21.2386 18 19 20.2386 19 23C19 25.7614 21.2386 28 24 28Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EnergyMono;
